import { useMutation } from '@tanstack/react-query';

import { logout } from '../api/auth.api';

import { useAuth } from './useAuth';

export function useLogout() {
  const { clearSession } = useAuth();

  return useMutation({
    mutationFn: logout,
    onSettled: clearSession,
  });
}
